import IOSSDK from "../../../../src/mdx/sdk/ios.mdx";
import * as React from 'react';
export default {
  IOSSDK,
  React
};